import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useFestivalMapUrl } from "@/hooks/useFestivalMapUrl";

/**
 * Preview thumbnail + remove control for a briefing's persisted festival
 * map. The signed URL resolution is encapsulated here so callers only
 * need to track the storage path.
 */
export function FestivalMapPreview({
  storagePath,
  onRemove,
}: {
  storagePath: string | null;
  onRemove: () => void;
}) {
  const url = useFestivalMapUrl({ map_storage_path: storagePath });
  return (
    <div className="max-w-full space-y-3 overflow-hidden">
      {url ? (
        <img
          src={url}
          alt="Festival map"
          className="mx-auto max-h-[500px] w-full rounded-lg object-contain"
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      ) : (
        <div className="flex h-32 items-center justify-center text-sm text-muted-foreground">
          Loading map…
        </div>
      )}
      <Button variant="outline" onClick={onRemove} className="mt-2">
        <X className="mr-2 h-4 w-4" />
        Remove Map
      </Button>
    </div>
  );
}
